import { styled } from "styled-components";

export const ScreenHeader = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: ${({ theme }) => theme.spacing[4]};

  @media (max-width: 768px) {
    flex-direction: column-reverse;
    align-items: flex-start;
    padding-bottom: ${({ theme }) => theme.spacing[3]};
  }
`;

export const HeaderTiles = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${({ theme }) => theme.spacing[5]};
`;

export const ListTile = styled.div`
  margin-top: ${({ theme }) => theme.spacing[4]};
  background-color: ${({ theme }) => theme.colors.background.layers[700]};
  overflow: hidden;
  padding: ${({ theme }) => theme.spacing[4]};

  @media (max-width: 768px) {
    margin-top: ${({ theme }) => theme.spacing[3]};
  }
`;

export const Spacer = styled.div`
  flex: 1;
`;

export const NextButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ theme }) => theme.spacing[5]};
  min-width: ${({ theme }) => theme.spacing[5]};
  height: ${({ theme }) => theme.spacing[5]};
  transition: background-color 0.2s ease;
  background-color: ${({ theme }) => theme.colors.background.layers[600]};
`;

export const IconCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ theme }) => theme.spacing[5]};
  min-width: ${({ theme }) => theme.spacing[5]};
  height: ${({ theme }) => theme.spacing[5]};
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.background.grundfos.primary};
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[4]};
`;

export const BackButtonWrapper = styled.div`
  @media (max-width: 768px) {
    display: none;
  }
`;

export const CreateButtonWrapper = styled.div`
  @media (max-width: 768px) {
    margin-bottom: ${({ theme }) => theme.spacing[3]};
    align-self: flex-end;
  }
`;
